import iconArrow from "@/img/arrow-up-icon.svg";
import iconDown from "@/img/arrow-down-icon.svg";

import "./style.scss";

type WeatherWithIconProps = {
	icon?: React.ReactNode;
	tempMax: string | number;
	tempMin: string | number;
	type: "marine" | "world" | "weather";
};

export const WeatherWithIcon = ({
	icon,
	tempMax,
	tempMin,
	type,
}: WeatherWithIconProps) => {
	return (
		<div className="weather-with-icon">
			{type === "marine" ? null : icon ? (
				icon
			) : (
				<div className="empty-icon">-</div>
			)}

			<div className="temp-card">
				<div className="temp-data max-temp-card">
					<img
						src={iconArrow}
						draggable={false}
						className="arrow-up"
						alt="max temps icon"
					/>
					<p>
						{tempMax} {type === "marine" ? "ft" : "°C"}{" "}
					</p>
				</div>

				<div className="temp-data min-temp-card">
					<img
						className="arrow-down"
						draggable={false}
						src={iconDown}
						alt="max temps icon"
					/>
					<p>
						{tempMin} {type === "marine" ? "ft" : "°C"}
					</p>
				</div>
			</div>
		</div>
	);
};

export default WeatherWithIcon;
